import { FC, RefObject, useEffect, useMemo } from 'react'
import { ImageType } from 'react-images-uploading'
import { Carousel } from 'react-responsive-carousel'

import LinkCarouselItem from './LinkCarouselItem'
import { TMediaCallbacks } from '../../../../../pages/CreatePost'

import {
  TAttachmentIds,
  TChangeAttachmentExtrafieldPayload,
  TExtendedPostAttachment,
  TRemoveAttachmentPayload
} from '../../../../../store/managePost/newTypes'

import 'react-responsive-carousel/lib/styles/carousel.min.css'
import '../UI.scss'
import { ATTACHMENT_DESCRIPTION_TYPE } from '../../../../../models/post'
import { TAccountLogo } from '../../../../../selectors/ProjectSelector'

type MultiLinkCarouselProps = {
  attachments: TExtendedPostAttachment[]
  refMediaCallbaks: RefObject<TMediaCallbacks>
  addLinkToAttachments: (isChildLink: boolean) => void
  setCarouselActiveAttachmentIds: (ids: TAttachmentIds) => any
  linkCarouselSelectedAttachmentIds: TAttachmentIds
  restrictions: any
  deattachAttachment: (data: TRemoveAttachmentPayload) => void
  setExtraField: (data: TChangeAttachmentExtrafieldPayload) => void
  addMediaToTemporaryLibrary: (data: ImageType, ids: TAttachmentIds) => void
  deleteMediaFromPostSocial: (id: TRemoveAttachmentPayload) => void
  isEditable: boolean
  logo: TAccountLogo
}

const MultiLinkCarousel: FC<MultiLinkCarouselProps> = ({
  refMediaCallbaks,
  attachments,
  logo,
  setExtraField,
  addLinkToAttachments,
  setCarouselActiveAttachmentIds,
  deattachAttachment,
  linkCarouselSelectedAttachmentIds,
  addMediaToTemporaryLibrary,
  deleteMediaFromPostSocial,
  isEditable,
  restrictions
}) => {
  const sortedAttachments = useMemo(() => {
    const result: TExtendedPostAttachment[] = [...attachments]
    const rootLinkIndex = attachments.findIndex(
      (attachment) => attachment.description === ATTACHMENT_DESCRIPTION_TYPE.LINK
    )

    if (rootLinkIndex !== -1) {
      const rootLink = result.splice(rootLinkIndex, 1)
      result.push(rootLink[0])
    }

    return result
  }, [attachments])

  useEffect(() => {
    const rootLink = sortedAttachments.find((attachment) => !attachment.extra_fields?.is_child_link)
    if (!rootLink) {
      addLinkToAttachments(false)
    }

    const attachmentsLength = rootLink ? sortedAttachments.length : sortedAttachments.length + 1

    if (attachmentsLength < restrictions.cards.min_cards) {
      for (let i = attachmentsLength; i < restrictions.cards.min_cards; i++) {
        addLinkToAttachments(true)
      }
    }

    if (sortedAttachments) {
      setCarouselActiveAttachmentIds({
        id: sortedAttachments[0]?.id,
        temporaryId: sortedAttachments[0]?.temporaryId
      })
    }
  }, [sortedAttachments])

  if (refMediaCallbaks.current)
    refMediaCallbaks.current.addChildLink = () => {
      addLinkToAttachments(true)
    }

  return (
    <div className='facebook-link-carousel__carousel-wrapper'>
      <Carousel
        showIndicators={false}
        dynamicHeight={false}
        showStatus={false}
        showThumbs={false}
        centerMode
        centerSlidePercentage={65}
        onChange={(index) =>
          setCarouselActiveAttachmentIds({
            id: sortedAttachments[index].id,
            temporaryId: sortedAttachments[index].temporaryId
          })
        }
        onClickItem={(index) =>
          setCarouselActiveAttachmentIds({
            id: sortedAttachments[index].id,
            temporaryId: sortedAttachments[index].temporaryId
          })
        }
      >
        {sortedAttachments.map((attachment, index) => {
          const attachmentIds = { id: attachment.id, temporaryId: attachment.temporaryId }

          const addImageToLinksToStore = (media: ImageType) => {
            addMediaToTemporaryLibrary(media, attachmentIds)
          }

          const removeImageFromLinkIntoStore = () => {
            deleteMediaFromPostSocial(attachmentIds)
          }

          return (
            <LinkCarouselItem
              {...{
                attachment,
                refMediaCallbaks,
                restrictions,
                isEditable,
                deattachAttachment,
                logo,
                setExtraField,
                addImageToLinksToStore,
                removeImageFromLinkIntoStore,
                key: index
              }}
            />
          )
        })}
      </Carousel>
    </div>
  )
}

export default MultiLinkCarousel
